import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'
import { SubjectType, SplitOption, DataItem } from '@aytm/app/insights/dashboard/models/types.ClientDTO'

export type StateSelectorParams = {
  isLoading: boolean
  isSharedView: boolean
  subjects: Record<string, SubjectType>
  splitOptions: SplitOption[]
  waveOptions: SplitOption[]
  data: Record<string, string | DataItem>
  blockChartType: string
  blockChartScale: string
  sortByAttribute: string | null
  sortByMethod: string | null
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const block = getCurrentBlock(state)
  const store = state.currentData
  return {
    isLoading: state.isLoading,
    isSharedView: state.isSharedView,
    subjects: store?.subjects || {},
    splitOptions: store?.splitOptions || [],
    waveOptions: store?.waveOptions || [],
    data: store?.data || {},
    blockChartType: block?.get<string>('blockChartType') || 'line',
    blockChartScale: block?.get<string>('blockChartScale') || 'min-max',
    sortByAttribute: block?.get<string>('sortByAttribute') || null,
    sortByMethod: block?.get<string>('sortByMethod') || null
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : next.isLoading
    ? false
    : prev.isSharedView !== next.isSharedView ||
      prev.subjects !== next.subjects ||
      prev.splitOptions !== next.splitOptions ||
      prev.waveOptions !== next.waveOptions ||
      prev.data !== next.data ||
      prev.blockChartType !== next.blockChartType ||
      prev.blockChartScale !== next.blockChartScale ||
      prev.sortByAttribute !== next.sortByAttribute ||
      prev.sortByMethod !== next.sortByMethod
